// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workflow-dropdown {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0px;
  width: 50%;
}
.export-button-container {
  text-align: right;
  margin-top: 10px;
}
.workflow-dropdown-container {
  display: flex;
  width: 70%;
}
.workflow-dropdown-column {
  margin-bottom: 10px;
  width: 100%;
}
.search-container {
  background-color: #eeeeee;
  border: 1px solid lightgray;
  padding: 10px;
}
.left-group {
  display: flex;
}
.right-group {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-weight: bold;
  font-size: 12px;
}
.right-group span {
  margin-bottom: 3px;
}
.right-group span input {
  margin-left: 7px;
}
.search-bar {
  width: 40em;
}
.search-button {
  margin-left: 10px;
}
.search-option {
  display: flex;
  align-items: center;
}
.results-box {
  border: 2px solid red;
}
.centered-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.greyed-out {
  color: lightgray;
}
:root {
  --magview-purple: #8D66C4;
}
.progress-bar {
  background-color: var(--magview-purple);
}
.tooltip-icon {
  margin-left: 2px;
  cursor: pointer;
  font-weight: bold;
  color: #007bff;
  /* Similar to a hyperlink color */
  font-size: 22px;
  /* Adjust size as needed */
}
#timeout-selection-div {
  width: 95px;
  margin-bottom: 10px;
}
panel-successbody {
  background-color: #5f259f;
}
body > img {
  position: absolute;
  left: 0;
  top: 52px;
  width: 100%;
  height: auto;
  z-index: 1;
  opacity: 0.4;
}
.navbar-inverse .navbar-nav.navbar-right > li > a {
  padding: 15px 12px;
  font-size: 14px;
}
.inactive {
  background-color: grey;
}
.container.container-transparent {
  background: transparent;
}
.top-tile-wrapper > .tile {
  z-index: 3;
  width: 19%;
  float: left;
  margin: 0 4%;
}
.top-tile-wrapper > .tile:first-child {
  margin-left: 0;
}
.top-tile-wrapper > .tile:last-child {
  margin-right: 0;
}
.top-tile-wrapper > .tile div {
  z-index: 3;
  background: #fff;
  opacity: 0.8;
  padding: 20px 20px 5px 20px;
  text-align: center;
}
.top-tile-wrapper > .tile div i.fa {
  font-size: 100px;
  display: block;
  margin-bottom: 5px;
}
.top-tile-wrapper > .tile div a {
  font-size: 24px;
  font-weight: bold;
  color: #714C77;
  text-decoration: none;
}
.top-tile-wrapper > .tile div a p {
  font-size: 12px;
  min-height: 34px;
}
.home-header {
  color: #fff;
  font-size: 26px;
  opacity: 0.8;
  float: left;
}
.home-header p {
  font-size: 14px;
  margin-top: 6px;
}
.home-box {
  background: white;
  margin-top: 10px;
  margin-bottom: 30px;
  /*opacity: 0.85;*/
}
.home-box .main {
  padding: 25px;
}
.home-box .main .select2-container {
  width: 300px;
  float: left;
  margin-right: 10px;
}
.home-box .main .select2-container .select2-choice {
  height: 34px;
  line-height: 32px;
}
.home-box .main button {
  float: left;
}
.home-box .main button::after {
  clear: both;
}
.home-box .bottom {
  background: #ECE9F0;
  min-height: 50px;
}
.home-box .bottom.tools {
  padding: 25px 30px;
}
.home-box .bottom.tools a,
.home-box .bottom.tools a:visited {
  color: #848188;
  text-decoration: none;
  margin-right: 30px;
}
.home-box h2 {
  margin: 0;
}
.home-box p {
  color: gray;
  margin: 0;
}
.system-status {
  margin-top: 30px;
  color: #fff;
  border: 2px solid #fff;
  padding: 5px 50px 5px 5px;
  border-radius: 31px;
  float: right;
  opacity: 0.8;
}
.system-status i {
  float: left;
  background: #fff;
  color: #000;
  border-radius: 24px;
  padding: 7px;
  font-size: 26px;
  color: #714C77;
}
.system-status p {
  font-size: 16px;
  line-height: 40px;
  white-space: nowrap;
  margin: 0;
  font-weight: bold;
  margin-left: 75px;
}
.system-status hr {
  border-top-color: #E4E4E4;
}
ul.tasks-summary {
  list-style-type: none;
  border-radius: 25px;
  border: 1px solid #E4E4E4;
  padding: 0;
  margin-top: 45px;
}
ul.tasks-summary li {
  padding: 8px 25px;
  height: 50px;
  border-bottom: 1px solid #E4E4E4;
}
ul.tasks-summary li a,
ul.tasks-summary li a:visited {
  text-decoration: none;
  color: #292F2F;
}
ul.tasks-summary li:last-child {
  border: none;
}
ul.tasks-summary li .task-name {
  font-weight: bold;
  line-height: 35px;
}
ul.tasks-summary li .task-date {
  color: #B9B9B9;
  margin-left: 5px;
  line-height: 35px;
}
ul.tasks-summary li .task-status {
  float: right;
  font-weight: bold;
  line-height: 25px;
}
ul.tasks-summary li .task-status i.fa {
  border: 2px solid black;
  border-radius: 16px;
  padding: 5px;
  font-size: 18px;
}
ul.tasks-summary li .task-status.success {
  color: #6FA899;
}
ul.tasks-summary li .task-status.success i.fa {
  border-color: #6FA899;
}
ul.tasks-summary li .task-status.error {
  color: #EB6666;
}
ul.tasks-summary li .task-status.error i.fa {
  border-color: #EB6666;
}
.btn-status-block {
  width: 80px;
}
.status-history-page {
  /*
  * Datepicker element
  */
}
.status-history-page time-filter input {
  margin-top: 0 !important;
}
.status-history-page .dataTables_processing {
  z-index: 11;
}
.status-history-page .datepicker.dropdown-menu {
  width: 250px;
  height: 270px;
}
.status-history-page .datepicker.dropdown-menu button {
  outline: none;
  border: 0px;
}
.status-history-page .datepicker.dropdown-menu tbody {
  height: 180px;
}
.status-history-page .datepicker.dropdown-menu tbody button {
  padding: 6px;
}
.status-history-page .datepicker.dropdown-menu.datepicker-mode-1 tbody button,
.status-history-page .datepicker.dropdown-menu.datepicker-mode-2 tbody button {
  height: 65px;
}
.status-history-page .table tr td {
  word-break: break-word;
}
.status-history-page .popover {
  max-width: 500px;
  word-break: break-word;
  width: 500px;
  outline: none;
  white-space: pre-wrap;
  /* Since CSS 2.1 */
  white-space: -moz-pre-wrap;
  /* Mozilla, since 1999 */
  white-space: -pre-wrap;
  /* Opera 4-6 */
  white-space: -o-pre-wrap;
  /* Opera 7 */
}
.current-status-page.big-rows .row {
  padding-bottom: 10px;
}
.current-status-page.big-rows .task-status-line {
  padding-top: 7px;
  padding-bottom: 2px;
  margin-bottom: 20px;
}
.current-status-page.big-rows .row.title-row {
  border-top: none;
  padding-left: 15px;
  padding-bottom: 10px;
  padding-top: 5px;
}
.current-status-page.big-rows .row.status-line-row {
  border-top: none;
  padding: 0px 10px 1px 45px;
}
.current-status-page.big-rows .popover {
  max-width: 500px;
  word-break: break-word;
  width: 500px;
  outline: none;
  white-space: pre-wrap;
  /* Since CSS 2.1 */
  white-space: -moz-pre-wrap;
  /* Mozilla, since 1999 */
  white-space: -pre-wrap;
  /* Opera 4-6 */
  white-space: -o-pre-wrap;
  /* Opera 7 */
}
.break-word {
  word-wrap: break-word;
}
.identifier-label {
  font-weight: normal;
  width: 100%;
}
.cell-word-wrap {
  max-width: 200px;
  word-wrap: break-word;
}
.timer-config-modal {
  width: 800px;
}
.timer-config-modal .select {
  border: 1px solid #d0d8df;
  border-radius: 2px;
  color: #1e1e1e;
  font-size: 12px;
  line-height: normal;
  outline: medium none;
  transition-duration: 150ms;
  transition-timing-function: ease;
  box-shadow: none;
}
.magtac-settings-general input {
  margin-top: 4px !important;
}
.magtac-settings-general .list-group .list-group-item {
  height: 50px;
  line-height: 40px;
  margin: 0;
  padding: 3px 0px;
  padding-left: 20px;
  margin-bottom: -1px;
}
.magtac-settings-general .list-group .list-group-item .btn.disabled {
  cursor: default;
  opacity: 0.75;
}
.magtac-settings-general .list-group .list-group-item b {
  min-width: 50px;
  display: inline-block;
}
.magtac-settings-general .btn-primary,
.magtac-settings-general .btn-default {
  margin-top: 4px;
}
.magtac-dashboard-page .status-box {
  margin-top: 10px;
}
.magtac-dashboard-page .status-box .dropdown-menu {
  overflow: auto !important;
}
.magtac-dashboard-page .tasks-box {
  margin-top: 10px;
}
.magtac-dashboard-page .tasks-box .dropdown-menu {
  overflow: auto !important;
}
.magtac-dashboard-page .current-time-element {
  display: none;
}
.magtac-dashboard-page .desktop-mode {
  display: block;
}
.magtac-dashboard-page .fullscreen-mode {
  display: none;
}
.magtac-dashboard-page .header-section {
  margin-bottom: 30px;
}
@media (min-width: 1200px) {
  .magtac-dashboard-page .col-lg-3 {
    width: 33.33333333%;
  }
}
.magtac-dashboard-page .content-section .panel {
  margin-bottom: 1px;
  border: 0px;
  border-radius: 0;
  padding-top: 2px;
  padding-left: 0;
  height: 40px;
  column-gap: 1em;
}
.magtac-dashboard-page .content-section .panel .panel-heading {
  border-radius: 0;
  padding-left: 0;
  height: 34px;
  color: white;
}
.magtac-dashboard-page .content-section .panel .panel-heading .panel-title {
  font-size: 15px;
  font-weight: bold;
  text-align: left;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}
.magtac-dashboard-page .content-section .panel .panel-heading .panel-title i.fa {
  font-size: 15px;
  margin-right: 5px;
}
.magtac-dashboard-page .content-section .panel .panel-body {
  font-size: 12px;
  padding-top: 2px;
  padding-left: 0;
  height: 34px;
  color: white;
}
.magtac-dashboard-page .content-section .panel .panel-body .details-message {
  height: 20px;
}
.magtac-dashboard-page .content-section .panel .panel-footer {
  font-size: 12px;
  border-top: 0;
  padding-top: 1px;
  padding-left: 0;
  height: 34px;
  color: white;
}
.magtac-dashboard-page .content-section .panel .panel-footer-Right {
  font-size: 12px;
  border-top: 0;
  padding-top: 1px;
  padding-left: 0;
  height: 34px;
  color: white;
}
.magtac-dashboard-page .content-section .panel.panel-danger {
  background: #AF1D20;
}
.magtac-dashboard-page .content-section .panel.panel-danger .panel-body {
  background: #AF1D20;
}
.magtac-dashboard-page .content-section .panel.panel-danger .panel-footer {
  background: #AF1D20;
}
.magtac-dashboard-page .content-section .panel.panel-danger .panel-footer-Right {
  background: #AF1D20;
}
.magtac-dashboard-page .content-section .panel.panel-warning {
  background: #BF5E22;
}
.magtac-dashboard-page .content-section .panel.panel-warning .panel-heading .panel-title i.fa {
  margin-left: 3px;
  margin-right: 9px;
}
.magtac-dashboard-page .content-section .panel.panel-warning .panel-body {
  background: #BF5E22;
}
.magtac-dashboard-page .content-section .panel.panel-warning .panel-footer {
  background: #BF5E22;
}
.magtac-dashboard-page .content-section .panel.panel-warning .panel-footer-Right {
  background: #BF5E22;
}
.magtac-dashboard-page .content-section .panel.panel-expired {
  background: #BF962D;
}
.magtac-dashboard-page .content-section .panel.panel-expired .panel-heading .panel-title i.fa {
  margin-left: 3px;
  margin-right: 9px;
}
.magtac-dashboard-page .content-section .panel.panel-expired .panel-body {
  background: #BF962D;
}
.magtac-dashboard-page .content-section .panel.panel-expired .panel-footer {
  background: #BF962D;
}
.magtac-dashboard-page .content-section .panel.panel-expired .panel-footer-Right {
  background: #BF962D;
}
.magtac-dashboard-page .content-section .panel.panel-success {
  background: #308127;
}
.magtac-dashboard-page .content-section .panel.panel-success .panel-body {
  background: #308127;
}
.magtac-dashboard-page .content-section .panel.panel-success .panel-footer {
  background: #308127;
}
.magtac-dashboard-page .content-section .panel.panel-success .panel-footer-Right {
  background: #308127;
}
.magtac-dashboard-page .content-section .panel.panel-waiting {
  background: #5bc0de;
}
.magtac-dashboard-page .content-section .panel.panel-waiting .panel-body {
  background: #5bc0de;
}
.magtac-dashboard-page .content-section .panel.panel-waiting .panel-footer {
  background: #5bc0de;
}
.magtac-dashboard-page .content-section .panel.panel-waiting .panel-footer-Right {
  background: #5bc0de;
}
.magtac-dashboard-page .content-section .panel.panel-skipped {
  background: #5bc0de;
}
.magtac-dashboard-page .content-section .panel.panel-skipped .panel-body {
  background: #5bc0de;
}
.magtac-dashboard-page .content-section .panel.panel-skipped .panel-footer {
  background: #5bc0de;
}
.magtac-dashboard-page .content-section .panel.panel-skipped .panel-footer-Right {
  background: #5bc0de;
}
.magtac-dashboard-page-wallboard {
  background: #0F1214;
  height: 100%;
  max-width: 100%;
}
.magtac-dashboard-page-wallboard .status-box {
  display: none;
}
.magtac-dashboard-page-wallboard .desktop-mode {
  display: none;
}
.magtac-dashboard-page-wallboard .fullscreen-mode {
  display: block;
}
@media (min-width: 1200px) {
  .magtac-dashboard-page-wallboard .col-lg-3 {
    width: 25%;
  }
}
.magtac-dashboard-page-wallboard .current-time-element {
  display: block;
}
.magtac-dashboard-page-wallboard .current-time-element .panel-body {
  margin-top: 20px;
  font-size: 30px !important;
}
.magtac-dashboard-page-wallboard .header-section {
  margin-bottom: 30px;
  color: #eee;
}
.magtac-dashboard-page-wallboard .content-section .panel {
  border-radius: 0;
  padding-top: 20px;
  height: 260px;
  border: none;
}
.magtac-dashboard-page-wallboard .content-section .panel .panel-heading {
  border-radius: 0;
  border: none;
  height: 120px;
}
.magtac-dashboard-page-wallboard .content-section .panel .panel-heading .panel-title {
  margin-top: 10px;
  font-size: 39px;
  text-align: center;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 10px;
  padding-right: 10px;
  height: 100%;
}
.magtac-dashboard-page-wallboard .content-section .panel .panel-heading .panel-title a {
  height: 100%;
  line-height: 100px;
}
.magtac-dashboard-page-wallboard .content-section .panel .panel-heading .panel-title i.fa {
  font-size: 30px;
}
.magtac-dashboard-page-wallboard .content-section .panel .panel-heading .panel-title.large-text {
  font-size: 90px;
}
.magtac-dashboard-page-wallboard .content-section .panel .panel-body {
  font-size: 30px;
  color: white;
  margin-top: 20px;
}
.magtac-dashboard-page-wallboard .content-section .panel .panel-body .details-message {
  height: 60px;
}
.magtac-dashboard-page-wallboard .content-section .panel .panel-body .col-xs-6.text-right {
  padding-left: 0px;
  padding-right: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  min-height: 84px;
}
.magtac-dashboard-page-wallboard .content-section .panel .panel-body .col-xs-6.text-left {
  padding-left: 20px;
  padding-right: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  min-height: 84px;
}
.magtac-dashboard-page-wallboard .content-section .panel.panel-danger {
  background: #AE070C;
}
.magtac-dashboard-page-wallboard .content-section .panel.panel-danger .panel-heading {
  background: #AE070C;
}
.magtac-dashboard-page-wallboard .content-section .panel.panel-danger .panel-body {
  background: #AE070C;
}
.magtac-dashboard-page-wallboard .content-section .panel.panel-warning {
  background: #BF5E22;
}
.magtac-dashboard-page-wallboard .content-section .panel.panel-warning .panel-heading {
  background: #BF5E22;
}
.magtac-dashboard-page-wallboard .content-section .panel.panel-warning .panel-body {
  background: #BF5E22;
}
.magtac-dashboard-page-wallboard .content-section .panel.panel-success {
  background: #2A2A2A;
}
.magtac-dashboard-page-wallboard .content-section .panel.panel-success .panel-heading {
  background: #2A2A2A;
}
.magtac-dashboard-page-wallboard .content-section .panel.panel-success .panel-body {
  background: #2A2A2A;
}
.magtac-dashboard-page-wallboard .content-section .panel.animated {
  animation-duration: 1.5s;
  animation-fill-mode: both;
  transition-timing-function: linear;
  animation-name: fadeOut;
  animation-iteration-count: infinite;
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.85;
  }
  100% {
    opacity: 1;
  }
}
:-ms-fullscreen .magtac-dashboard-page {
  background: #0F1214;
  height: 100%;
  max-width: 100%;
}
:fullscreen .magtac-dashboard-page {
  background: #0F1214;
  height: 100%;
  max-width: 100%;
}
:-ms-fullscreen .magtac-dashboard-page .status-box {
  display: none;
}
:fullscreen .magtac-dashboard-page .status-box {
  display: none;
}
:-ms-fullscreen .magtac-dashboard-page .desktop-mode {
  display: none;
}
:fullscreen .magtac-dashboard-page .desktop-mode {
  display: none;
}
:-ms-fullscreen .magtac-dashboard-page .fullscreen-mode {
  display: block;
}
:fullscreen .magtac-dashboard-page .fullscreen-mode {
  display: block;
}
@media (min-width: 1200px) {
  :-ms-fullscreen .magtac-dashboard-page .col-lg-3 {
    width: 25%;
  }
  :fullscreen .magtac-dashboard-page .col-lg-3 {
    width: 25%;
  }
}
:-ms-fullscreen .magtac-dashboard-page .current-time-element {
  display: block;
}
:fullscreen .magtac-dashboard-page .current-time-element {
  display: block;
}
:-ms-fullscreen .magtac-dashboard-page .current-time-element .panel-body {
  margin-top: 20px;
  font-size: 30px !important;
}
:fullscreen .magtac-dashboard-page .current-time-element .panel-body {
  margin-top: 20px;
  font-size: 30px !important;
}
:-ms-fullscreen .magtac-dashboard-page .header-section {
  margin-bottom: 30px;
  color: #eee;
}
:fullscreen .magtac-dashboard-page .header-section {
  margin-bottom: 30px;
  color: #eee;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel {
  border-radius: 0;
  padding-top: 20px;
  height: 260px;
  border: none;
}
:fullscreen .magtac-dashboard-page .content-section .panel {
  border-radius: 0;
  padding-top: 20px;
  height: 260px;
  border: none;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-heading {
  border-radius: 0;
  border: none;
  height: 120px;
}
:fullscreen .magtac-dashboard-page .content-section .panel .panel-heading {
  border-radius: 0;
  border: none;
  height: 120px;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title {
  margin-top: 10px;
  font-size: 39px;
  text-align: center;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 10px;
  padding-right: 10px;
  height: 100%;
}
:fullscreen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title {
  margin-top: 10px;
  font-size: 39px;
  text-align: center;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 10px;
  padding-right: 10px;
  height: 100%;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title a {
  height: 100%;
  line-height: 100px;
}
:fullscreen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title a {
  height: 100%;
  line-height: 100px;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title i.fa {
  font-size: 30px;
}
:fullscreen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title i.fa {
  font-size: 30px;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title.large-text {
  font-size: 90px;
}
:fullscreen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title.large-text {
  font-size: 90px;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-body {
  font-size: 30px;
  color: white;
  margin-top: 20px;
}
:fullscreen .magtac-dashboard-page .content-section .panel .panel-body {
  font-size: 30px;
  color: white;
  margin-top: 20px;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-body .details-message {
  height: 60px;
}
:fullscreen .magtac-dashboard-page .content-section .panel .panel-body .details-message {
  height: 60px;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-body .col-xs-6.text-right {
  padding-left: 0px;
  padding-right: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  min-height: 84px;
}
:fullscreen .magtac-dashboard-page .content-section .panel .panel-body .col-xs-6.text-right {
  padding-left: 0px;
  padding-right: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  min-height: 84px;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-body .col-xs-6.text-left {
  padding-left: 20px;
  padding-right: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  min-height: 84px;
}
:fullscreen .magtac-dashboard-page .content-section .panel .panel-body .col-xs-6.text-left {
  padding-left: 20px;
  padding-right: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  min-height: 84px;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-danger {
  background: #AE070C;
}
:fullscreen .magtac-dashboard-page .content-section .panel.panel-danger {
  background: #AE070C;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-danger .panel-heading {
  background: #AE070C;
}
:fullscreen .magtac-dashboard-page .content-section .panel.panel-danger .panel-heading {
  background: #AE070C;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-danger .panel-body {
  background: #AE070C;
}
:fullscreen .magtac-dashboard-page .content-section .panel.panel-danger .panel-body {
  background: #AE070C;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-warning {
  background: #BF5E22;
}
:fullscreen .magtac-dashboard-page .content-section .panel.panel-warning {
  background: #BF5E22;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-warning .panel-heading {
  background: #BF5E22;
}
:fullscreen .magtac-dashboard-page .content-section .panel.panel-warning .panel-heading {
  background: #BF5E22;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-warning .panel-body {
  background: #BF5E22;
}
:fullscreen .magtac-dashboard-page .content-section .panel.panel-warning .panel-body {
  background: #BF5E22;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-success {
  background: #2A2A2A;
}
:fullscreen .magtac-dashboard-page .content-section .panel.panel-success {
  background: #2A2A2A;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-success .panel-heading {
  background: #2A2A2A;
}
:fullscreen .magtac-dashboard-page .content-section .panel.panel-success .panel-heading {
  background: #2A2A2A;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-success .panel-body {
  background: #2A2A2A;
}
:fullscreen .magtac-dashboard-page .content-section .panel.panel-success .panel-body {
  background: #2A2A2A;
}
:-ms-fullscreen .magtac-dashboard-page .content-section .panel.animated {
  animation-duration: 1.5s;
  animation-fill-mode: both;
  transition-timing-function: linear;
  animation-name: fadeOut;
  animation-iteration-count: infinite;
}
:fullscreen .magtac-dashboard-page .content-section .panel.animated {
  animation-duration: 1.5s;
  animation-fill-mode: both;
  transition-timing-function: linear;
  animation-name: fadeOut;
  animation-iteration-count: infinite;
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.85;
  }
  100% {
    opacity: 1;
  }
}
:-webkit-full-screen .magtac-dashboard-page {
  background: #0F1214;
  height: 100%;
  max-width: 100%;
}
:-webkit-full-screen .magtac-dashboard-page .status-box {
  display: none;
}
:-webkit-full-screen .magtac-dashboard-page .desktop-mode {
  display: none;
}
:-webkit-full-screen .magtac-dashboard-page .fullscreen-mode {
  display: block;
}
@media (min-width: 1200px) {
  :-webkit-full-screen .magtac-dashboard-page .col-lg-3 {
    width: 25%;
  }
}
:-webkit-full-screen .magtac-dashboard-page .current-time-element {
  display: block;
}
:-webkit-full-screen .magtac-dashboard-page .current-time-element .panel-body {
  margin-top: 20px;
  font-size: 30px !important;
}
:-webkit-full-screen .magtac-dashboard-page .header-section {
  margin-bottom: 30px;
  color: #eee;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel {
  border-radius: 0;
  padding-top: 20px;
  height: 260px;
  border: none;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-heading {
  border-radius: 0;
  border: none;
  height: 120px;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title {
  margin-top: 10px;
  font-size: 39px;
  text-align: center;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 10px;
  padding-right: 10px;
  height: 100%;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title a {
  height: 100%;
  line-height: 100px;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title i.fa {
  font-size: 30px;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title.large-text {
  font-size: 90px;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-body {
  font-size: 30px;
  color: white;
  margin-top: 20px;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-body .details-message {
  height: 60px;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-body .col-xs-6.text-right {
  padding-left: 0px;
  padding-right: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  min-height: 84px;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-body .col-xs-6.text-left {
  padding-left: 20px;
  padding-right: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  min-height: 84px;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-danger {
  background: #AE070C;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-danger .panel-heading {
  background: #AE070C;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-danger .panel-body {
  background: #AE070C;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-warning {
  background: #BF5E22;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-warning .panel-heading {
  background: #BF5E22;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-warning .panel-body {
  background: #BF5E22;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-success {
  background: #2A2A2A;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-success .panel-heading {
  background: #2A2A2A;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-success .panel-body {
  background: #2A2A2A;
}
:-webkit-full-screen .magtac-dashboard-page .content-section .panel.animated {
  animation-duration: 1.5s;
  animation-fill-mode: both;
  transition-timing-function: linear;
  animation-name: fadeOut;
  animation-iteration-count: infinite;
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.85;
  }
  100% {
    opacity: 1;
  }
}
:-moz-full-screen .magtac-dashboard-page {
  background: #0F1214;
  height: 100%;
  max-width: 100%;
}
:-moz-full-screen .magtac-dashboard-page .status-box {
  display: none;
}
:-moz-full-screen .magtac-dashboard-page .desktop-mode {
  display: none;
}
:-moz-full-screen .magtac-dashboard-page .fullscreen-mode {
  display: block;
}
@media (min-width: 1200px) {
  :-moz-full-screen .magtac-dashboard-page .col-lg-3 {
    width: 25%;
  }
}
:-moz-full-screen .magtac-dashboard-page .current-time-element {
  display: block;
}
:-moz-full-screen .magtac-dashboard-page .current-time-element .panel-body {
  margin-top: 20px;
  font-size: 30px !important;
}
:-moz-full-screen .magtac-dashboard-page .header-section {
  margin-bottom: 30px;
  color: #eee;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel {
  border-radius: 0;
  padding-top: 20px;
  height: 260px;
  border: none;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-heading {
  border-radius: 0;
  border: none;
  height: 120px;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title {
  margin-top: 10px;
  font-size: 39px;
  text-align: center;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 10px;
  padding-right: 10px;
  height: 100%;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title a {
  height: 100%;
  line-height: 100px;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title i.fa {
  font-size: 30px;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title.large-text {
  font-size: 90px;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-body {
  font-size: 30px;
  color: white;
  margin-top: 20px;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-body .details-message {
  height: 60px;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-body .col-xs-6.text-right {
  padding-left: 0px;
  padding-right: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  min-height: 84px;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-body .col-xs-6.text-left {
  padding-left: 20px;
  padding-right: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  min-height: 84px;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-danger {
  background: #AE070C;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-danger .panel-heading {
  background: #AE070C;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-danger .panel-body {
  background: #AE070C;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-warning {
  background: #BF5E22;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-warning .panel-heading {
  background: #BF5E22;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-warning .panel-body {
  background: #BF5E22;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-success {
  background: #2A2A2A;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-success .panel-heading {
  background: #2A2A2A;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-success .panel-body {
  background: #2A2A2A;
}
:-moz-full-screen .magtac-dashboard-page .content-section .panel.animated {
  animation-duration: 1.5s;
  animation-fill-mode: both;
  transition-timing-function: linear;
  animation-name: fadeOut;
  animation-iteration-count: infinite;
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.85;
  }
  100% {
    opacity: 1;
  }
}
.btn.collapse-expand-btn,
.btn.collapse-expand-btn:focus,
.btn.collapse-expand-btn:hover,
.btn.collapse-expand-btn:active {
  background-color: transparent;
  border: none;
  color: #333;
  padding: 0;
  margin-left: 25px;
  outline: 0;
}
.btn.btn-expired {
  color: #fff;
  background-color: #BF962D;
  border-color: #BF962D;
}
.runnow-btn {
  padding: 2px 10px;
}
.ignore-btn {
  padding: 2px 10px;
}
.ticket-btn {
  width: 100px;
  padding: 2px 10px;
}
.btn-h3-inline {
  margin-top: 20px;
}
.library-upload-dialog .upload-zone.drop-box .placeholder-msg {
  display: block;
}
.magtac-libraries-page .header-section h3 {
  margin-top: 10px;
  margin-bottom: 25px;
}
.magtac-libraries-page .header-section .btn-primary,
.magtac-libraries-page .header-section .btn-default {
  margin-top: 10px;
}
.magtac-libraries-page .left-panel {
  border-right: 1px solid #ddd;
  min-height: 400px;
  padding-top: 15px;
}
.magtac-libraries-page .left-panel .list-group {
  border-radius: 0;
}
.magtac-libraries-page .left-panel .list-group .list-group-item {
  border-radius: 0;
  border-width: 0;
}
.magtac-libraries-page .left-panel .list-group .list-group-item.active {
  background-color: #ffffff;
  border-color: #337ab7;
  border-width: 2px !important;
  color: #337ab7;
}
.magtac-libraries-page .right-panel {
  margin-top: 17px;
}
.magtac-libraries-page .right-panel .description-column {
  white-space: pre;
  word-break: break-all;
  word-wrap: break-word;
  overflow: auto;
}
.table.not-over-width tr td {
  word-break: break-word;
}
.table tr td.center,
.table tr th.center {
  text-align: center;
}
.long-status-details {
  margin-top: 20px;
  white-space: pre-wrap;
}
.observer-longdetails-html table.table {
  white-space: normal;
}
.m-t-10 {
  margin-top: 10px;
}
.short-paging .paging_simple_numbers > span > a:last-child {
  display: none;
}
.short-paging .paging_simple_numbers .previous,
.short-paging .paging_simple_numbers .next {
  display: none;
}
.text-left-bold {
  text-align: left;
  font-weight: bold;
}
.code {
  overflow-x: scroll;
  white-space: pre;
}
`, "",{"version":3,"sources":["webpack://./src/components/magtac/styles/magtac.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uCAAuC;AACzC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,gCAAgC;AAClC;AACA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE;;GAEC;AACH;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,wBAAwB;EACxB,sBAAsB;EACtB,cAAc;EACd,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,wBAAwB;EACxB,sBAAsB;EACtB,cAAc;EACd,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kCAAkC;EAClC,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kCAAkC;EAClC,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kCAAkC;EAClC,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kCAAkC;EAClC,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kCAAkC;EAClC,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;AACA;;;;EAIE,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;;EAEE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".workflow-dropdown {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 0px;\n  width: 50%;\n}\n.export-button-container {\n  text-align: right;\n  margin-top: 10px;\n}\n.workflow-dropdown-container {\n  display: flex;\n  width: 70%;\n}\n.workflow-dropdown-column {\n  margin-bottom: 10px;\n  width: 100%;\n}\n.search-container {\n  background-color: #eeeeee;\n  border: 1px solid lightgray;\n  padding: 10px;\n}\n.left-group {\n  display: flex;\n}\n.right-group {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  font-weight: bold;\n  font-size: 12px;\n}\n.right-group span {\n  margin-bottom: 3px;\n}\n.right-group span input {\n  margin-left: 7px;\n}\n.search-bar {\n  width: 40em;\n}\n.search-button {\n  margin-left: 10px;\n}\n.search-option {\n  display: flex;\n  align-items: center;\n}\n.results-box {\n  border: 2px solid red;\n}\n.centered-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.greyed-out {\n  color: lightgray;\n}\n:root {\n  --magview-purple: #8D66C4;\n}\n.progress-bar {\n  background-color: var(--magview-purple);\n}\n.tooltip-icon {\n  margin-left: 2px;\n  cursor: pointer;\n  font-weight: bold;\n  color: #007bff;\n  /* Similar to a hyperlink color */\n  font-size: 22px;\n  /* Adjust size as needed */\n}\n#timeout-selection-div {\n  width: 95px;\n  margin-bottom: 10px;\n}\npanel-successbody {\n  background-color: #5f259f;\n}\nbody > img {\n  position: absolute;\n  left: 0;\n  top: 52px;\n  width: 100%;\n  height: auto;\n  z-index: 1;\n  opacity: 0.4;\n}\n.navbar-inverse .navbar-nav.navbar-right > li > a {\n  padding: 15px 12px;\n  font-size: 14px;\n}\n.inactive {\n  background-color: grey;\n}\n.container.container-transparent {\n  background: transparent;\n}\n.top-tile-wrapper > .tile {\n  z-index: 3;\n  width: 19%;\n  float: left;\n  margin: 0 4%;\n}\n.top-tile-wrapper > .tile:first-child {\n  margin-left: 0;\n}\n.top-tile-wrapper > .tile:last-child {\n  margin-right: 0;\n}\n.top-tile-wrapper > .tile div {\n  z-index: 3;\n  background: #fff;\n  opacity: 0.8;\n  padding: 20px 20px 5px 20px;\n  text-align: center;\n}\n.top-tile-wrapper > .tile div i.fa {\n  font-size: 100px;\n  display: block;\n  margin-bottom: 5px;\n}\n.top-tile-wrapper > .tile div a {\n  font-size: 24px;\n  font-weight: bold;\n  color: #714C77;\n  text-decoration: none;\n}\n.top-tile-wrapper > .tile div a p {\n  font-size: 12px;\n  min-height: 34px;\n}\n.home-header {\n  color: #fff;\n  font-size: 26px;\n  opacity: 0.8;\n  float: left;\n}\n.home-header p {\n  font-size: 14px;\n  margin-top: 6px;\n}\n.home-box {\n  background: white;\n  margin-top: 10px;\n  margin-bottom: 30px;\n  /*opacity: 0.85;*/\n}\n.home-box .main {\n  padding: 25px;\n}\n.home-box .main .select2-container {\n  width: 300px;\n  float: left;\n  margin-right: 10px;\n}\n.home-box .main .select2-container .select2-choice {\n  height: 34px;\n  line-height: 32px;\n}\n.home-box .main button {\n  float: left;\n}\n.home-box .main button::after {\n  clear: both;\n}\n.home-box .bottom {\n  background: #ECE9F0;\n  min-height: 50px;\n}\n.home-box .bottom.tools {\n  padding: 25px 30px;\n}\n.home-box .bottom.tools a,\n.home-box .bottom.tools a:visited {\n  color: #848188;\n  text-decoration: none;\n  margin-right: 30px;\n}\n.home-box h2 {\n  margin: 0;\n}\n.home-box p {\n  color: gray;\n  margin: 0;\n}\n.system-status {\n  margin-top: 30px;\n  color: #fff;\n  border: 2px solid #fff;\n  padding: 5px 50px 5px 5px;\n  border-radius: 31px;\n  float: right;\n  opacity: 0.8;\n}\n.system-status i {\n  float: left;\n  background: #fff;\n  color: #000;\n  border-radius: 24px;\n  padding: 7px;\n  font-size: 26px;\n  color: #714C77;\n}\n.system-status p {\n  font-size: 16px;\n  line-height: 40px;\n  white-space: nowrap;\n  margin: 0;\n  font-weight: bold;\n  margin-left: 75px;\n}\n.system-status hr {\n  border-top-color: #E4E4E4;\n}\nul.tasks-summary {\n  list-style-type: none;\n  border-radius: 25px;\n  border: 1px solid #E4E4E4;\n  padding: 0;\n  margin-top: 45px;\n}\nul.tasks-summary li {\n  padding: 8px 25px;\n  height: 50px;\n  border-bottom: 1px solid #E4E4E4;\n}\nul.tasks-summary li a,\nul.tasks-summary li a:visited {\n  text-decoration: none;\n  color: #292F2F;\n}\nul.tasks-summary li:last-child {\n  border: none;\n}\nul.tasks-summary li .task-name {\n  font-weight: bold;\n  line-height: 35px;\n}\nul.tasks-summary li .task-date {\n  color: #B9B9B9;\n  margin-left: 5px;\n  line-height: 35px;\n}\nul.tasks-summary li .task-status {\n  float: right;\n  font-weight: bold;\n  line-height: 25px;\n}\nul.tasks-summary li .task-status i.fa {\n  border: 2px solid black;\n  border-radius: 16px;\n  padding: 5px;\n  font-size: 18px;\n}\nul.tasks-summary li .task-status.success {\n  color: #6FA899;\n}\nul.tasks-summary li .task-status.success i.fa {\n  border-color: #6FA899;\n}\nul.tasks-summary li .task-status.error {\n  color: #EB6666;\n}\nul.tasks-summary li .task-status.error i.fa {\n  border-color: #EB6666;\n}\n.btn-status-block {\n  width: 80px;\n}\n.status-history-page {\n  /*\n  * Datepicker element\n  */\n}\n.status-history-page time-filter input {\n  margin-top: 0 !important;\n}\n.status-history-page .dataTables_processing {\n  z-index: 11;\n}\n.status-history-page .datepicker.dropdown-menu {\n  width: 250px;\n  height: 270px;\n}\n.status-history-page .datepicker.dropdown-menu button {\n  outline: none;\n  border: 0px;\n}\n.status-history-page .datepicker.dropdown-menu tbody {\n  height: 180px;\n}\n.status-history-page .datepicker.dropdown-menu tbody button {\n  padding: 6px;\n}\n.status-history-page .datepicker.dropdown-menu.datepicker-mode-1 tbody button,\n.status-history-page .datepicker.dropdown-menu.datepicker-mode-2 tbody button {\n  height: 65px;\n}\n.status-history-page .table tr td {\n  word-break: break-word;\n}\n.status-history-page .popover {\n  max-width: 500px;\n  word-break: break-word;\n  width: 500px;\n  outline: none;\n  white-space: pre-wrap;\n  /* Since CSS 2.1 */\n  white-space: -moz-pre-wrap;\n  /* Mozilla, since 1999 */\n  white-space: -pre-wrap;\n  /* Opera 4-6 */\n  white-space: -o-pre-wrap;\n  /* Opera 7 */\n}\n.current-status-page.big-rows .row {\n  padding-bottom: 10px;\n}\n.current-status-page.big-rows .task-status-line {\n  padding-top: 7px;\n  padding-bottom: 2px;\n  margin-bottom: 20px;\n}\n.current-status-page.big-rows .row.title-row {\n  border-top: none;\n  padding-left: 15px;\n  padding-bottom: 10px;\n  padding-top: 5px;\n}\n.current-status-page.big-rows .row.status-line-row {\n  border-top: none;\n  padding: 0px 10px 1px 45px;\n}\n.current-status-page.big-rows .popover {\n  max-width: 500px;\n  word-break: break-word;\n  width: 500px;\n  outline: none;\n  white-space: pre-wrap;\n  /* Since CSS 2.1 */\n  white-space: -moz-pre-wrap;\n  /* Mozilla, since 1999 */\n  white-space: -pre-wrap;\n  /* Opera 4-6 */\n  white-space: -o-pre-wrap;\n  /* Opera 7 */\n}\n.break-word {\n  word-wrap: break-word;\n}\n.identifier-label {\n  font-weight: normal;\n  width: 100%;\n}\n.cell-word-wrap {\n  max-width: 200px;\n  word-wrap: break-word;\n}\n.timer-config-modal {\n  width: 800px;\n}\n.timer-config-modal .select {\n  border: 1px solid #d0d8df;\n  border-radius: 2px;\n  color: #1e1e1e;\n  font-size: 12px;\n  line-height: normal;\n  outline: medium none;\n  transition-duration: 150ms;\n  transition-timing-function: ease;\n  box-shadow: none;\n}\n.magtac-settings-general input {\n  margin-top: 4px !important;\n}\n.magtac-settings-general .list-group .list-group-item {\n  height: 50px;\n  line-height: 40px;\n  margin: 0;\n  padding: 3px 0px;\n  padding-left: 20px;\n  margin-bottom: -1px;\n}\n.magtac-settings-general .list-group .list-group-item .btn.disabled {\n  cursor: default;\n  opacity: 0.75;\n}\n.magtac-settings-general .list-group .list-group-item b {\n  min-width: 50px;\n  display: inline-block;\n}\n.magtac-settings-general .btn-primary,\n.magtac-settings-general .btn-default {\n  margin-top: 4px;\n}\n.magtac-dashboard-page .status-box {\n  margin-top: 10px;\n}\n.magtac-dashboard-page .status-box .dropdown-menu {\n  overflow: auto !important;\n}\n.magtac-dashboard-page .tasks-box {\n  margin-top: 10px;\n}\n.magtac-dashboard-page .tasks-box .dropdown-menu {\n  overflow: auto !important;\n}\n.magtac-dashboard-page .current-time-element {\n  display: none;\n}\n.magtac-dashboard-page .desktop-mode {\n  display: block;\n}\n.magtac-dashboard-page .fullscreen-mode {\n  display: none;\n}\n.magtac-dashboard-page .header-section {\n  margin-bottom: 30px;\n}\n@media (min-width: 1200px) {\n  .magtac-dashboard-page .col-lg-3 {\n    width: 33.33333333%;\n  }\n}\n.magtac-dashboard-page .content-section .panel {\n  margin-bottom: 1px;\n  border: 0px;\n  border-radius: 0;\n  padding-top: 2px;\n  padding-left: 0;\n  height: 40px;\n  column-gap: 1em;\n}\n.magtac-dashboard-page .content-section .panel .panel-heading {\n  border-radius: 0;\n  padding-left: 0;\n  height: 34px;\n  color: white;\n}\n.magtac-dashboard-page .content-section .panel .panel-heading .panel-title {\n  font-size: 15px;\n  font-weight: bold;\n  text-align: left;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n}\n.magtac-dashboard-page .content-section .panel .panel-heading .panel-title i.fa {\n  font-size: 15px;\n  margin-right: 5px;\n}\n.magtac-dashboard-page .content-section .panel .panel-body {\n  font-size: 12px;\n  padding-top: 2px;\n  padding-left: 0;\n  height: 34px;\n  color: white;\n}\n.magtac-dashboard-page .content-section .panel .panel-body .details-message {\n  height: 20px;\n}\n.magtac-dashboard-page .content-section .panel .panel-footer {\n  font-size: 12px;\n  border-top: 0;\n  padding-top: 1px;\n  padding-left: 0;\n  height: 34px;\n  color: white;\n}\n.magtac-dashboard-page .content-section .panel .panel-footer-Right {\n  font-size: 12px;\n  border-top: 0;\n  padding-top: 1px;\n  padding-left: 0;\n  height: 34px;\n  color: white;\n}\n.magtac-dashboard-page .content-section .panel.panel-danger {\n  background: #AF1D20;\n}\n.magtac-dashboard-page .content-section .panel.panel-danger .panel-body {\n  background: #AF1D20;\n}\n.magtac-dashboard-page .content-section .panel.panel-danger .panel-footer {\n  background: #AF1D20;\n}\n.magtac-dashboard-page .content-section .panel.panel-danger .panel-footer-Right {\n  background: #AF1D20;\n}\n.magtac-dashboard-page .content-section .panel.panel-warning {\n  background: #BF5E22;\n}\n.magtac-dashboard-page .content-section .panel.panel-warning .panel-heading .panel-title i.fa {\n  margin-left: 3px;\n  margin-right: 9px;\n}\n.magtac-dashboard-page .content-section .panel.panel-warning .panel-body {\n  background: #BF5E22;\n}\n.magtac-dashboard-page .content-section .panel.panel-warning .panel-footer {\n  background: #BF5E22;\n}\n.magtac-dashboard-page .content-section .panel.panel-warning .panel-footer-Right {\n  background: #BF5E22;\n}\n.magtac-dashboard-page .content-section .panel.panel-expired {\n  background: #BF962D;\n}\n.magtac-dashboard-page .content-section .panel.panel-expired .panel-heading .panel-title i.fa {\n  margin-left: 3px;\n  margin-right: 9px;\n}\n.magtac-dashboard-page .content-section .panel.panel-expired .panel-body {\n  background: #BF962D;\n}\n.magtac-dashboard-page .content-section .panel.panel-expired .panel-footer {\n  background: #BF962D;\n}\n.magtac-dashboard-page .content-section .panel.panel-expired .panel-footer-Right {\n  background: #BF962D;\n}\n.magtac-dashboard-page .content-section .panel.panel-success {\n  background: #308127;\n}\n.magtac-dashboard-page .content-section .panel.panel-success .panel-body {\n  background: #308127;\n}\n.magtac-dashboard-page .content-section .panel.panel-success .panel-footer {\n  background: #308127;\n}\n.magtac-dashboard-page .content-section .panel.panel-success .panel-footer-Right {\n  background: #308127;\n}\n.magtac-dashboard-page .content-section .panel.panel-waiting {\n  background: #5bc0de;\n}\n.magtac-dashboard-page .content-section .panel.panel-waiting .panel-body {\n  background: #5bc0de;\n}\n.magtac-dashboard-page .content-section .panel.panel-waiting .panel-footer {\n  background: #5bc0de;\n}\n.magtac-dashboard-page .content-section .panel.panel-waiting .panel-footer-Right {\n  background: #5bc0de;\n}\n.magtac-dashboard-page .content-section .panel.panel-skipped {\n  background: #5bc0de;\n}\n.magtac-dashboard-page .content-section .panel.panel-skipped .panel-body {\n  background: #5bc0de;\n}\n.magtac-dashboard-page .content-section .panel.panel-skipped .panel-footer {\n  background: #5bc0de;\n}\n.magtac-dashboard-page .content-section .panel.panel-skipped .panel-footer-Right {\n  background: #5bc0de;\n}\n.magtac-dashboard-page-wallboard {\n  background: #0F1214;\n  height: 100%;\n  max-width: 100%;\n}\n.magtac-dashboard-page-wallboard .status-box {\n  display: none;\n}\n.magtac-dashboard-page-wallboard .desktop-mode {\n  display: none;\n}\n.magtac-dashboard-page-wallboard .fullscreen-mode {\n  display: block;\n}\n@media (min-width: 1200px) {\n  .magtac-dashboard-page-wallboard .col-lg-3 {\n    width: 25%;\n  }\n}\n.magtac-dashboard-page-wallboard .current-time-element {\n  display: block;\n}\n.magtac-dashboard-page-wallboard .current-time-element .panel-body {\n  margin-top: 20px;\n  font-size: 30px !important;\n}\n.magtac-dashboard-page-wallboard .header-section {\n  margin-bottom: 30px;\n  color: #eee;\n}\n.magtac-dashboard-page-wallboard .content-section .panel {\n  border-radius: 0;\n  padding-top: 20px;\n  height: 260px;\n  border: none;\n}\n.magtac-dashboard-page-wallboard .content-section .panel .panel-heading {\n  border-radius: 0;\n  border: none;\n  height: 120px;\n}\n.magtac-dashboard-page-wallboard .content-section .panel .panel-heading .panel-title {\n  margin-top: 10px;\n  font-size: 39px;\n  text-align: center;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n  color: white;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-left: 10px;\n  padding-right: 10px;\n  height: 100%;\n}\n.magtac-dashboard-page-wallboard .content-section .panel .panel-heading .panel-title a {\n  height: 100%;\n  line-height: 100px;\n}\n.magtac-dashboard-page-wallboard .content-section .panel .panel-heading .panel-title i.fa {\n  font-size: 30px;\n}\n.magtac-dashboard-page-wallboard .content-section .panel .panel-heading .panel-title.large-text {\n  font-size: 90px;\n}\n.magtac-dashboard-page-wallboard .content-section .panel .panel-body {\n  font-size: 30px;\n  color: white;\n  margin-top: 20px;\n}\n.magtac-dashboard-page-wallboard .content-section .panel .panel-body .details-message {\n  height: 60px;\n}\n.magtac-dashboard-page-wallboard .content-section .panel .panel-body .col-xs-6.text-right {\n  padding-left: 0px;\n  padding-right: 20px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  min-height: 84px;\n}\n.magtac-dashboard-page-wallboard .content-section .panel .panel-body .col-xs-6.text-left {\n  padding-left: 20px;\n  padding-right: 0px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  min-height: 84px;\n}\n.magtac-dashboard-page-wallboard .content-section .panel.panel-danger {\n  background: #AE070C;\n}\n.magtac-dashboard-page-wallboard .content-section .panel.panel-danger .panel-heading {\n  background: #AE070C;\n}\n.magtac-dashboard-page-wallboard .content-section .panel.panel-danger .panel-body {\n  background: #AE070C;\n}\n.magtac-dashboard-page-wallboard .content-section .panel.panel-warning {\n  background: #BF5E22;\n}\n.magtac-dashboard-page-wallboard .content-section .panel.panel-warning .panel-heading {\n  background: #BF5E22;\n}\n.magtac-dashboard-page-wallboard .content-section .panel.panel-warning .panel-body {\n  background: #BF5E22;\n}\n.magtac-dashboard-page-wallboard .content-section .panel.panel-success {\n  background: #2A2A2A;\n}\n.magtac-dashboard-page-wallboard .content-section .panel.panel-success .panel-heading {\n  background: #2A2A2A;\n}\n.magtac-dashboard-page-wallboard .content-section .panel.panel-success .panel-body {\n  background: #2A2A2A;\n}\n.magtac-dashboard-page-wallboard .content-section .panel.animated {\n  animation-duration: 1.5s;\n  animation-fill-mode: both;\n  transition-timing-function: linear;\n  animation-name: fadeOut;\n  animation-iteration-count: infinite;\n}\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.85;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n:-ms-fullscreen .magtac-dashboard-page {\n  background: #0F1214;\n  height: 100%;\n  max-width: 100%;\n}\n:fullscreen .magtac-dashboard-page {\n  background: #0F1214;\n  height: 100%;\n  max-width: 100%;\n}\n:-ms-fullscreen .magtac-dashboard-page .status-box {\n  display: none;\n}\n:fullscreen .magtac-dashboard-page .status-box {\n  display: none;\n}\n:-ms-fullscreen .magtac-dashboard-page .desktop-mode {\n  display: none;\n}\n:fullscreen .magtac-dashboard-page .desktop-mode {\n  display: none;\n}\n:-ms-fullscreen .magtac-dashboard-page .fullscreen-mode {\n  display: block;\n}\n:fullscreen .magtac-dashboard-page .fullscreen-mode {\n  display: block;\n}\n@media (min-width: 1200px) {\n  :-ms-fullscreen .magtac-dashboard-page .col-lg-3 {\n    width: 25%;\n  }\n  :fullscreen .magtac-dashboard-page .col-lg-3 {\n    width: 25%;\n  }\n}\n:-ms-fullscreen .magtac-dashboard-page .current-time-element {\n  display: block;\n}\n:fullscreen .magtac-dashboard-page .current-time-element {\n  display: block;\n}\n:-ms-fullscreen .magtac-dashboard-page .current-time-element .panel-body {\n  margin-top: 20px;\n  font-size: 30px !important;\n}\n:fullscreen .magtac-dashboard-page .current-time-element .panel-body {\n  margin-top: 20px;\n  font-size: 30px !important;\n}\n:-ms-fullscreen .magtac-dashboard-page .header-section {\n  margin-bottom: 30px;\n  color: #eee;\n}\n:fullscreen .magtac-dashboard-page .header-section {\n  margin-bottom: 30px;\n  color: #eee;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel {\n  border-radius: 0;\n  padding-top: 20px;\n  height: 260px;\n  border: none;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel {\n  border-radius: 0;\n  padding-top: 20px;\n  height: 260px;\n  border: none;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-heading {\n  border-radius: 0;\n  border: none;\n  height: 120px;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel .panel-heading {\n  border-radius: 0;\n  border: none;\n  height: 120px;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title {\n  margin-top: 10px;\n  font-size: 39px;\n  text-align: center;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n  color: white;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-left: 10px;\n  padding-right: 10px;\n  height: 100%;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title {\n  margin-top: 10px;\n  font-size: 39px;\n  text-align: center;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n  color: white;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-left: 10px;\n  padding-right: 10px;\n  height: 100%;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title a {\n  height: 100%;\n  line-height: 100px;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title a {\n  height: 100%;\n  line-height: 100px;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title i.fa {\n  font-size: 30px;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title i.fa {\n  font-size: 30px;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title.large-text {\n  font-size: 90px;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title.large-text {\n  font-size: 90px;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-body {\n  font-size: 30px;\n  color: white;\n  margin-top: 20px;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel .panel-body {\n  font-size: 30px;\n  color: white;\n  margin-top: 20px;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-body .details-message {\n  height: 60px;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel .panel-body .details-message {\n  height: 60px;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-body .col-xs-6.text-right {\n  padding-left: 0px;\n  padding-right: 20px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  min-height: 84px;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel .panel-body .col-xs-6.text-right {\n  padding-left: 0px;\n  padding-right: 20px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  min-height: 84px;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel .panel-body .col-xs-6.text-left {\n  padding-left: 20px;\n  padding-right: 0px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  min-height: 84px;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel .panel-body .col-xs-6.text-left {\n  padding-left: 20px;\n  padding-right: 0px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  min-height: 84px;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-danger {\n  background: #AE070C;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel.panel-danger {\n  background: #AE070C;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-danger .panel-heading {\n  background: #AE070C;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel.panel-danger .panel-heading {\n  background: #AE070C;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-danger .panel-body {\n  background: #AE070C;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel.panel-danger .panel-body {\n  background: #AE070C;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-warning {\n  background: #BF5E22;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel.panel-warning {\n  background: #BF5E22;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-warning .panel-heading {\n  background: #BF5E22;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel.panel-warning .panel-heading {\n  background: #BF5E22;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-warning .panel-body {\n  background: #BF5E22;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel.panel-warning .panel-body {\n  background: #BF5E22;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-success {\n  background: #2A2A2A;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel.panel-success {\n  background: #2A2A2A;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-success .panel-heading {\n  background: #2A2A2A;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel.panel-success .panel-heading {\n  background: #2A2A2A;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel.panel-success .panel-body {\n  background: #2A2A2A;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel.panel-success .panel-body {\n  background: #2A2A2A;\n}\n:-ms-fullscreen .magtac-dashboard-page .content-section .panel.animated {\n  animation-duration: 1.5s;\n  animation-fill-mode: both;\n  transition-timing-function: linear;\n  animation-name: fadeOut;\n  animation-iteration-count: infinite;\n}\n:fullscreen .magtac-dashboard-page .content-section .panel.animated {\n  animation-duration: 1.5s;\n  animation-fill-mode: both;\n  transition-timing-function: linear;\n  animation-name: fadeOut;\n  animation-iteration-count: infinite;\n}\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.85;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n:-webkit-full-screen .magtac-dashboard-page {\n  background: #0F1214;\n  height: 100%;\n  max-width: 100%;\n}\n:-webkit-full-screen .magtac-dashboard-page .status-box {\n  display: none;\n}\n:-webkit-full-screen .magtac-dashboard-page .desktop-mode {\n  display: none;\n}\n:-webkit-full-screen .magtac-dashboard-page .fullscreen-mode {\n  display: block;\n}\n@media (min-width: 1200px) {\n  :-webkit-full-screen .magtac-dashboard-page .col-lg-3 {\n    width: 25%;\n  }\n}\n:-webkit-full-screen .magtac-dashboard-page .current-time-element {\n  display: block;\n}\n:-webkit-full-screen .magtac-dashboard-page .current-time-element .panel-body {\n  margin-top: 20px;\n  font-size: 30px !important;\n}\n:-webkit-full-screen .magtac-dashboard-page .header-section {\n  margin-bottom: 30px;\n  color: #eee;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel {\n  border-radius: 0;\n  padding-top: 20px;\n  height: 260px;\n  border: none;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-heading {\n  border-radius: 0;\n  border: none;\n  height: 120px;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title {\n  margin-top: 10px;\n  font-size: 39px;\n  text-align: center;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n  color: white;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-left: 10px;\n  padding-right: 10px;\n  height: 100%;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title a {\n  height: 100%;\n  line-height: 100px;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title i.fa {\n  font-size: 30px;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title.large-text {\n  font-size: 90px;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-body {\n  font-size: 30px;\n  color: white;\n  margin-top: 20px;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-body .details-message {\n  height: 60px;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-body .col-xs-6.text-right {\n  padding-left: 0px;\n  padding-right: 20px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  min-height: 84px;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel .panel-body .col-xs-6.text-left {\n  padding-left: 20px;\n  padding-right: 0px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  min-height: 84px;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-danger {\n  background: #AE070C;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-danger .panel-heading {\n  background: #AE070C;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-danger .panel-body {\n  background: #AE070C;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-warning {\n  background: #BF5E22;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-warning .panel-heading {\n  background: #BF5E22;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-warning .panel-body {\n  background: #BF5E22;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-success {\n  background: #2A2A2A;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-success .panel-heading {\n  background: #2A2A2A;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel.panel-success .panel-body {\n  background: #2A2A2A;\n}\n:-webkit-full-screen .magtac-dashboard-page .content-section .panel.animated {\n  animation-duration: 1.5s;\n  animation-fill-mode: both;\n  transition-timing-function: linear;\n  animation-name: fadeOut;\n  animation-iteration-count: infinite;\n}\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.85;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n:-moz-full-screen .magtac-dashboard-page {\n  background: #0F1214;\n  height: 100%;\n  max-width: 100%;\n}\n:-moz-full-screen .magtac-dashboard-page .status-box {\n  display: none;\n}\n:-moz-full-screen .magtac-dashboard-page .desktop-mode {\n  display: none;\n}\n:-moz-full-screen .magtac-dashboard-page .fullscreen-mode {\n  display: block;\n}\n@media (min-width: 1200px) {\n  :-moz-full-screen .magtac-dashboard-page .col-lg-3 {\n    width: 25%;\n  }\n}\n:-moz-full-screen .magtac-dashboard-page .current-time-element {\n  display: block;\n}\n:-moz-full-screen .magtac-dashboard-page .current-time-element .panel-body {\n  margin-top: 20px;\n  font-size: 30px !important;\n}\n:-moz-full-screen .magtac-dashboard-page .header-section {\n  margin-bottom: 30px;\n  color: #eee;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel {\n  border-radius: 0;\n  padding-top: 20px;\n  height: 260px;\n  border: none;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-heading {\n  border-radius: 0;\n  border: none;\n  height: 120px;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title {\n  margin-top: 10px;\n  font-size: 39px;\n  text-align: center;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n  color: white;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-left: 10px;\n  padding-right: 10px;\n  height: 100%;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title a {\n  height: 100%;\n  line-height: 100px;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title i.fa {\n  font-size: 30px;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-heading .panel-title.large-text {\n  font-size: 90px;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-body {\n  font-size: 30px;\n  color: white;\n  margin-top: 20px;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-body .details-message {\n  height: 60px;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-body .col-xs-6.text-right {\n  padding-left: 0px;\n  padding-right: 20px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  min-height: 84px;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel .panel-body .col-xs-6.text-left {\n  padding-left: 20px;\n  padding-right: 0px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  min-height: 84px;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-danger {\n  background: #AE070C;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-danger .panel-heading {\n  background: #AE070C;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-danger .panel-body {\n  background: #AE070C;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-warning {\n  background: #BF5E22;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-warning .panel-heading {\n  background: #BF5E22;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-warning .panel-body {\n  background: #BF5E22;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-success {\n  background: #2A2A2A;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-success .panel-heading {\n  background: #2A2A2A;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel.panel-success .panel-body {\n  background: #2A2A2A;\n}\n:-moz-full-screen .magtac-dashboard-page .content-section .panel.animated {\n  animation-duration: 1.5s;\n  animation-fill-mode: both;\n  transition-timing-function: linear;\n  animation-name: fadeOut;\n  animation-iteration-count: infinite;\n}\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.85;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.btn.collapse-expand-btn,\n.btn.collapse-expand-btn:focus,\n.btn.collapse-expand-btn:hover,\n.btn.collapse-expand-btn:active {\n  background-color: transparent;\n  border: none;\n  color: #333;\n  padding: 0;\n  margin-left: 25px;\n  outline: 0;\n}\n.btn.btn-expired {\n  color: #fff;\n  background-color: #BF962D;\n  border-color: #BF962D;\n}\n.runnow-btn {\n  padding: 2px 10px;\n}\n.ignore-btn {\n  padding: 2px 10px;\n}\n.ticket-btn {\n  width: 100px;\n  padding: 2px 10px;\n}\n.btn-h3-inline {\n  margin-top: 20px;\n}\n.library-upload-dialog .upload-zone.drop-box .placeholder-msg {\n  display: block;\n}\n.magtac-libraries-page .header-section h3 {\n  margin-top: 10px;\n  margin-bottom: 25px;\n}\n.magtac-libraries-page .header-section .btn-primary,\n.magtac-libraries-page .header-section .btn-default {\n  margin-top: 10px;\n}\n.magtac-libraries-page .left-panel {\n  border-right: 1px solid #ddd;\n  min-height: 400px;\n  padding-top: 15px;\n}\n.magtac-libraries-page .left-panel .list-group {\n  border-radius: 0;\n}\n.magtac-libraries-page .left-panel .list-group .list-group-item {\n  border-radius: 0;\n  border-width: 0;\n}\n.magtac-libraries-page .left-panel .list-group .list-group-item.active {\n  background-color: #ffffff;\n  border-color: #337ab7;\n  border-width: 2px !important;\n  color: #337ab7;\n}\n.magtac-libraries-page .right-panel {\n  margin-top: 17px;\n}\n.magtac-libraries-page .right-panel .description-column {\n  white-space: pre;\n  word-break: break-all;\n  word-wrap: break-word;\n  overflow: auto;\n}\n.table.not-over-width tr td {\n  word-break: break-word;\n}\n.table tr td.center,\n.table tr th.center {\n  text-align: center;\n}\n.long-status-details {\n  margin-top: 20px;\n  white-space: pre-wrap;\n}\n.observer-longdetails-html table.table {\n  white-space: normal;\n}\n.m-t-10 {\n  margin-top: 10px;\n}\n.short-paging .paging_simple_numbers > span > a:last-child {\n  display: none;\n}\n.short-paging .paging_simple_numbers .previous,\n.short-paging .paging_simple_numbers .next {\n  display: none;\n}\n.text-left-bold {\n  text-align: left;\n  font-weight: bold;\n}\n.code {\n  overflow-x: scroll;\n  white-space: pre;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
